'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _createReducer;

var _createReducer2 = require('../createReducer');

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function compareItemToggle(compareState, _ref) {
  var id = _ref.id,
      itemType = _ref.itemType,
      _ref$limit = _ref.limit,
      limit = _ref$limit === undefined ? 5 : _ref$limit;

  var items = compareState.items || [];
  if (!items.includes(id)) {
    items = [id].concat(compareState.type === itemType ? items || [] : []).reduce(function (result, item) {
      if (!result.includes(item)) {
        return [].concat((0, _toConsumableArray3.default)(result), [item]);
      }

      return result;
    }, []).slice(0, limit);
  } else {
    items.splice(items.indexOf(id), 1);
  }

  var newState = (0, _extends3.default)({}, compareState, {
    type: itemType,
    items: items
  });

  if (!process.env.REACT_APP_SERVER) {
    window.localStorage.setItem('compare', (0, _stringify2.default)(newState));
  }

  return newState;
}

function compareCancel() {
  window.localStorage.removeItem('compare');
  return {};
}

function rehydrate() {
  return !process.env.REACT_APP_SERVER ? JSON.parse(window.localStorage.getItem('compare') || '{}') : {};
}

var reducer = (0, _createReducer3.default)({}, (_createReducer = {
  '@@redux/INIT': rehydrate
}, (0, _defineProperty3.default)(_createReducer, _actions.COMPARE_TOGGLE_ITEM, compareItemToggle), (0, _defineProperty3.default)(_createReducer, _actions.COMPARE_CANCEL, compareCancel), _createReducer));

exports.default = reducer;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Compare/reducer.js
// module id = 859
// module chunks = 0